(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-csc-ba]:not([data-csc-ba-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-csc-ba-init', '');

      var tabs = root.querySelectorAll('[data-csc-ba-tab]');
      var quotes = root.querySelectorAll('[data-csc-ba-panel]');
      var compares = root.querySelectorAll('[data-csc-ba-compare]');
      var dots = root.querySelectorAll('[data-csc-ba-dots] .csc-ba__dot');
      var prevBtn = root.querySelector('[data-csc-ba-prev]');
      var nextBtn = root.querySelector('[data-csc-ba-next]');
      var countEl = root.querySelector('[data-csc-ba-count]');
      var daysEl = root.querySelector('[data-csc-ba-days]');

      var total = tabs.length;
      var current = 0;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function setActive(i) {
        if (total === 0) return;
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        current = i;

        tabs.forEach(function (el, idx) {
          var on = idx === i;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        quotes.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === i);
        });
        compares.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === i);
        });
        dots.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === i);
        });
        if (countEl) countEl.textContent = pad(i + 1) + ' / ' + pad(total);

        if (daysEl) {
          var active = compares[i];
          var days = active ? active.getAttribute('data-days') : '';
          daysEl.textContent = days || '';
        }

        var statEl = compares[i] ? compares[i].querySelector('[data-csc-ba-stat]') : null;
        if (statEl) animateStat(statEl);
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { setActive(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { setActive(i); });
      });

      function animateStat(el) {
        var raw = (el.getAttribute('data-target') || el.textContent || '').trim();
        if (!el.getAttribute('data-target')) el.setAttribute('data-target', raw);
        var match = raw.match(/^([\+\-]?[\d.]+)(.*)$/);
        if (!match) { el.textContent = raw; return; }
        var target = parseFloat(match[1]);
        var prefix = match[1].charAt(0) === '+' || match[1].charAt(0) === '-' ? match[1].charAt(0) : '';
        var absTarget = Math.abs(target);
        var suffix = match[2];
        var duration = 1400;
        var start = performance.now();
        function tick(now) {
          var t = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3);
          var cur = absTarget * eased;
          var formatted = absTarget % 1 === 0 ? Math.round(cur).toString() : cur.toFixed(1);
          el.textContent = prefix + formatted + suffix;
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }

      compares.forEach(function (compare) {
        var clip = compare.querySelector('[data-csc-ba-clip]');
        var divider = compare.querySelector('[data-csc-ba-divider]');
        var handle = compare.querySelector('[data-csc-ba-handle]');
        var hint = compare.querySelector('[data-csc-ba-hint]');
        if (!clip || !divider || !handle) return;

        var dragging = false;
        var pos = 50;

        function setPos(p) {
          pos = Math.max(0, Math.min(100, p));
          clip.style.width = pos + '%';
          divider.style.left = pos + '%';
          if (hint) hint.style.left = pos + '%';
          handle.setAttribute('aria-valuenow', Math.round(pos));
        }

        function fromClientX(clientX) {
          var rect = compare.getBoundingClientRect();
          var x = Math.max(0, Math.min(rect.width, clientX - rect.left));
          setPos((x / rect.width) * 100);
        }

        compare.addEventListener('mousedown', function (e) {
          dragging = true;
          compare.classList.add('is-dragging');
          fromClientX(e.clientX);
          e.preventDefault();
        });
        compare.addEventListener('touchstart', function (e) {
          dragging = true;
          compare.classList.add('is-dragging');
          fromClientX(e.touches[0].clientX);
        }, { passive: true });

        window.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          fromClientX(e.clientX);
        });
        window.addEventListener('touchmove', function (e) {
          if (!dragging) return;
          fromClientX(e.touches[0].clientX);
        }, { passive: true });

        window.addEventListener('mouseup', function () {
          if (!dragging) return;
          dragging = false;
          compare.classList.remove('is-dragging');
        });
        window.addEventListener('touchend', function () {
          if (!dragging) return;
          dragging = false;
          compare.classList.remove('is-dragging');
        });

        handle.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { setPos(pos - 4); e.preventDefault(); }
          if (e.key === 'ArrowRight') { setPos(pos + 4); e.preventDefault(); }
          if (e.key === 'Home') { setPos(0); e.preventDefault(); }
          if (e.key === 'End') { setPos(100); e.preventDefault(); }
        });

        setTimeout(function () {
          if (dragging) return;
          var frame = 0;
          var id = setInterval(function () {
            frame++;
            if (frame === 1) setPos(66);
            else if (frame === 2) setPos(38);
            else if (frame === 3) { setPos(50); clearInterval(id); }
          }, 500);
        }, 500);
      });

      setActive(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-csc-ing]:not([data-csc-ing-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-csc-ing-init', '');

      var scroller = root.querySelector('[data-csc-ing-cards]');
      var prevBtn = root.querySelector('[data-csc-ing-prev]');
      var nextBtn = root.querySelector('[data-csc-ing-next]');
      var dots = root.querySelectorAll('[data-csc-ing-dots] .csc-ing__ctrl-dot');
      if (!scroller) return;

      var cards = scroller.querySelectorAll('[data-csc-ing-card]');
      if (cards.length === 0) return;

      var current = 0;
      var total = cards.length;

      function updateActive() {
        var center = scroller.scrollLeft + scroller.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        cards.forEach(function (c, i) {
          var cCenter = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cCenter - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== current) {
          current = best;
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === current);
          });
          updateButtonState();
        }
      }

      function updateButtonState() {
        if (prevBtn) prevBtn.disabled = current <= 0;
        if (nextBtn) nextBtn.disabled = current >= total - 1;
      }

      function scrollToIndex(i) {
        i = Math.max(0, Math.min(total - 1, i));
        var card = cards[i];
        if (!card) return;
        var target = card.offsetLeft - (scroller.clientWidth - card.offsetWidth) / 2;
        scroller.scrollTo({ left: target, behavior: 'smooth' });
      }

      scroller.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateActive);
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(current + 1); });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { scrollToIndex(i); });
      });

      updateButtonState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-csc-pdp]:not([data-csc-pdp-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-csc-pdp-init', '');

      var plansEl = root.querySelector('script[data-csc-pdp-plans]');
      if (plansEl) {
        try {
          var plansData = JSON.parse(plansEl.textContent);
          console.log('[csc-pdp] product plan info:', plansData);
          var allCards = root.querySelectorAll('[data-csc-pdp-card="sub"]');
          console.log('[csc-pdp] sub cards:', Array.from(allCards).map(function (c) {
            return {
              planId: c.getAttribute('data-plan-id'),
              planName: c.getAttribute('data-plan-name'),
              isActive: c.classList.contains('is-on')
            };
          }));
        } catch (err) {
          console.warn('[csc-pdp] failed to parse plan info', err);
        }
      }

      var thumbs = root.querySelectorAll('[data-csc-pdp-thumb]');
      var mainScroller = root.querySelector('[data-csc-pdp-main]');
      var slides = mainScroller ? mainScroller.querySelectorAll('.csc-pdp__media-slide') : [];

      function isSwipeMode() {
        if (!mainScroller) return false;
        return getComputedStyle(mainScroller).overflowX !== 'hidden';
      }

      function setActiveSlide(i) {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        if (thumbs[i]) thumbs[i].classList.add('is-active');
        if (slides[i]) slides[i].classList.add('is-active');
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          setActiveSlide(i);
          if (isSwipeMode() && slides[i] && mainScroller) {
            mainScroller.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          }
        });
      });

      if (mainScroller) {
        var scrollFrame = null;
        mainScroller.addEventListener('scroll', function () {
          if (!isSwipeMode()) return;
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(function () {
            var center = mainScroller.scrollLeft + mainScroller.clientWidth / 2;
            var best = 0;
            var bestDist = Infinity;
            slides.forEach(function (s, i) {
              var sc = s.offsetLeft + s.offsetWidth / 2;
              var d = Math.abs(sc - center);
              if (d < bestDist) { bestDist = d; best = i; }
            });
            thumbs.forEach(function (x, i) {
              x.classList.toggle('is-active', i === best);
            });
          });
        }, { passive: true });
      }

      var optionSelects = root.querySelectorAll('[data-csc-pdp-option]');
      var variantInput = root.querySelector('[data-csc-pdp-variant-input]');
      var ctaPriceNow = root.querySelector('[data-csc-pdp-price-now]');
      var ctaPriceWas = root.querySelector('[data-csc-pdp-price-was]');
      var ctaLabel = root.querySelector('.csc-pdp__cta-label');
      var ctaBtn = root.querySelector('[data-csc-pdp-cta]');
      var productJsonEl = root.querySelector('script[type="application/json"][data-csc-pdp-product]');

      function formatMoney(cents) {
        var locale = (Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';
        var currency = (Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      function getProductData() {
        if (!productJsonEl) return null;
        try { return JSON.parse(productJsonEl.textContent); } catch (e) { return null; }
      }

      function updateFromOptions() {
        var data = getProductData();
        if (!data || !data.variants) return;
        var picked = [];
        optionSelects.forEach(function (sel) { picked.push(sel.value); });
        var match = data.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === picked[i]; });
        });
        if (!match) return;
        if (variantInput) variantInput.value = match.id;
        if (ctaPriceNow) ctaPriceNow.innerHTML = formatMoney(match.price);
        if (ctaPriceWas) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            ctaPriceWas.innerHTML = formatMoney(match.compare_at_price);
            ctaPriceWas.hidden = false;
          } else {
            ctaPriceWas.hidden = true;
          }
        }
        if (ctaBtn) {
          ctaBtn.disabled = !match.available;
          if (ctaLabel) ctaLabel.textContent = match.available ? (ctaBtn.getAttribute('data-cta-label') || ctaLabel.textContent) : 'Sold out';
        }
        var skioEl = root.querySelector('skio-plan-picker');
        if (skioEl && skioEl.selectedVariant !== undefined) {
          skioEl.selectedVariant = match;
        }
      }

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', updateFromOptions);
      });

      var seg = root.querySelector('[data-csc-pdp-mode]');
      var modeBtns = root.querySelectorAll('[data-csc-pdp-mode-btn]');
      var optGroups = root.querySelectorAll('[data-csc-pdp-opts]');
      var cards = root.querySelectorAll('[data-csc-pdp-card]');
      var sellingPlanInput = root.querySelector('[data-csc-pdp-selling-plan]');
      var qtyInput = root.querySelector('[data-csc-pdp-qty]');

      function applyCardPrice(card) {
        if (!card) return;
        var price = card.getAttribute('data-price');
        var compare = card.getAttribute('data-compare');
        if (ctaPriceNow && price) ctaPriceNow.innerHTML = price;
        if (ctaPriceWas) {
          if (compare) {
            ctaPriceWas.innerHTML = compare;
            ctaPriceWas.hidden = false;
          } else {
            ctaPriceWas.hidden = true;
          }
        }
      }

      function selectCard(card) {
        if (!card) return;
        var mode = card.getAttribute('data-csc-pdp-card');
        cards.forEach(function (c) {
          if (c.getAttribute('data-csc-pdp-card') === mode) {
            c.classList.toggle('is-on', c === card);
            var input = c.querySelector('.csc-pdp__opt-input');
            if (input) input.checked = (c === card);
          }
        });
        if (mode === 'sub') {
          if (sellingPlanInput) sellingPlanInput.value = card.getAttribute('data-plan-id') || '';
          if (qtyInput) qtyInput.value = '1';
        } else {
          if (sellingPlanInput) sellingPlanInput.value = '';
          if (qtyInput) qtyInput.value = card.getAttribute('data-qty') || '1';
        }
        applyCardPrice(card);
      }

      function setMode(mode) {
        if (seg) seg.setAttribute('data-csc-pdp-mode', mode);
        modeBtns.forEach(function (b) {
          b.classList.toggle('is-on', b.getAttribute('data-csc-pdp-mode-btn') === mode);
        });
        optGroups.forEach(function (g) {
          g.classList.toggle('is-hidden', g.getAttribute('data-csc-pdp-opts') !== mode);
        });
        var activeCards = root.querySelectorAll('[data-csc-pdp-card="' + mode + '"]');
        var checked = null;
        activeCards.forEach(function (c) { if (c.classList.contains('is-on')) checked = c; });
        if (!checked && activeCards.length) checked = activeCards[0];
        if (checked) selectCard(checked);
      }

      modeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          setMode(b.getAttribute('data-csc-pdp-mode-btn'));
        });
      });

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          selectCard(card);
        });
      });

      if (cards.length > 0) {
        var initialMode = seg ? seg.getAttribute('data-csc-pdp-mode') : 'sub';
        var modeCards = root.querySelectorAll('[data-csc-pdp-card="' + initialMode + '"]');
        var initial = null;
        modeCards.forEach(function (c) { if (c.classList.contains('is-on')) initial = c; });
        if (!initial && modeCards.length) initial = modeCards[0];
        cards.forEach(function (c) {
          if (c !== initial) {
            c.classList.remove('is-on');
            var inp = c.querySelector('.csc-pdp__opt-input');
            if (inp) inp.checked = false;
          }
        });
        if (initial) selectCard(initial);
      }

      function refreshCartDrawer() {
        var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var base = routeRoot.replace(/\/$/, '');
        return fetch(base + '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            return fetch(base + '/cart?section_id=api-cart-items', { headers: { 'Accept': 'text/html' } })
              .then(function (r) { return r.text(); })
              .then(function (html) { return { cart: cart, html: html }; });
          })
          .then(function (result) {
            var cart = result.cart;
            var temp = document.createElement('div');
            temp.innerHTML = result.html;
            var newContent = temp.querySelector('[data-api-content]');
            var drawer = document.querySelector('[data-cart-drawer]');

            if (drawer && newContent) {
              var pairs = [
                ['[data-api-line-items]', '[data-items-holder]'],
                ['[data-api-upsell-items]', '[data-pair-products-holder]'],
                ['[data-api-cart-price]', '[data-cart-price-holder]'],
                ['[data-cart-total]', '[data-cart-total]']
              ];
              pairs.forEach(function (pair) {
                var src = newContent.querySelector(pair[0]);
                var dst = drawer.querySelector(pair[1]);
                if (src && dst) dst.innerHTML = src.innerHTML;
              });

              var itemsHolder = drawer.querySelector('[data-items-holder]');
              var emptyMessage = drawer.querySelector('[data-empty-message]');
              if (cart.item_count > 0) {
                if (itemsHolder) itemsHolder.classList.remove('hidden');
                if (emptyMessage) emptyMessage.classList.add('hidden');
              } else {
                if (itemsHolder) itemsHolder.classList.add('hidden');
                if (emptyMessage) emptyMessage.classList.remove('hidden');
              }

              var heading = drawer.querySelector('[data-cart-drawer-title], .cart-drawer__title, .cart__title');
              if (heading) {
                var countEl = heading.querySelector('[data-cart-item-count], .cart-count, .count');
                if (countEl) {
                  countEl.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';
                } else {
                  var match = heading.textContent.match(/\((\d+)\s+items?\)/i);
                  if (match) {
                    heading.innerHTML = heading.innerHTML.replace(match[0], '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')');
                  }
                }
              }

              var subtotalWithoutCurrency = (cart.total_price || 0) / 100;
              var msgEl = drawer.querySelector('[data-cart-message]');
              if (msgEl) {
                var limit = parseFloat(msgEl.getAttribute('data-limit') || '0');
                if (limit > 0) {
                  var leftToSpend = Math.max(0, limit - subtotalWithoutCurrency);
                  var leftEl = msgEl.querySelector('[data-left-to-spend]');
                  if (leftEl) {
                    var currencyFmt;
                    try {
                      currencyFmt = new Intl.NumberFormat((window.Shopify && Shopify.locale) || 'en-US', { style: 'currency', currency: (cart.currency || 'USD'), minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(leftToSpend);
                    } catch (err) {
                      currencyFmt = '$' + leftToSpend.toFixed(2);
                    }
                    leftEl.textContent = currencyFmt;
                  }
                  if (subtotalWithoutCurrency >= limit) {
                    msgEl.classList.add('is-success');
                    var defaultMsg = msgEl.querySelector('[data-message-default]');
                    if (defaultMsg) defaultMsg.classList.add('is-hidden');
                  } else if (subtotalWithoutCurrency === 0) {
                    msgEl.classList.add('is-hidden');
                  } else {
                    msgEl.classList.remove('is-success', 'is-hidden');
                    var defaultMsg2 = msgEl.querySelector('[data-message-default]');
                    if (defaultMsg2) defaultMsg2.classList.remove('is-hidden');
                  }
                  var percent = limit > 0 ? Math.min(100, (subtotalWithoutCurrency / limit) * 100) : 0;
                  msgEl.querySelectorAll('[data-cart-message-progress]').forEach(function (p) {
                    p.value = percent;
                    p.style.setProperty('--progress-width', percent + '%');
                  });
                }
              }

              drawer.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
              if (cart.item_count === 0) {
                drawer.classList.add('is-empty');
                document.body.classList.add('cart-is-empty');
              } else {
                drawer.classList.remove('is-empty');
                document.body.classList.remove('cart-is-empty');
              }

              if (cart && cart.items) {
                cart.items.forEach(function (item) {
                  if (!item || !item.selling_plan_allocation) return;
                  var planName = item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name;
                  if (!planName) return;
                  var lineEl = drawer.querySelector('[data-cart-item][data-item="' + item.key + '"], [data-item="' + item.key + '"]');
                  if (!lineEl) return;
                  var existing = lineEl.querySelector('.cart__item__selling-plan, .csc-pdp-line-selling-plan');
                  if (existing) {
                    existing.classList.add('csc-pdp-line-selling-plan-shown');
                    if (!existing.textContent.trim()) {
                      existing.textContent = planName;
                    }
                  } else {
                    var meta = lineEl.querySelector('.cart__item__meta');
                    var titleEl = lineEl.querySelector('.cart__item__title');
                    var injectInto = meta || (titleEl && titleEl.parentElement);
                    if (injectInto) {
                      var label = document.createElement('p');
                      label.className = 'csc-pdp-line-selling-plan';
                      label.textContent = planName;
                      if (meta) {
                        meta.insertBefore(label, meta.firstChild);
                      } else if (titleEl) {
                        titleEl.parentElement.insertBefore(label, titleEl.nextSibling);
                      }
                    }
                  }
                });
              }
            }

            document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true, detail: { cart: cart } }));
            var bubbles = document.querySelectorAll('[data-cart-count], .cart-count, [data-header-cart-count], [data-cart-count-bubble]');
            bubbles.forEach(function (b) { b.textContent = cart.item_count; });

            return cart;
          });
      }

      (function delegateDrawerClicks() {
        var drawer = document.querySelector('[data-cart-drawer]');
        if (!drawer || drawer.hasAttribute('data-csc-pdp-drawer-bound')) return;
        drawer.setAttribute('data-csc-pdp-drawer-bound', '1');

        drawer.addEventListener('click', function (e) {
          var link = e.target && e.target.closest && e.target.closest('a[href*="/cart/change"], a[href*="/cart?"], a[href$="/cart"]');
          if (link) {
            var href = link.getAttribute('href') || '';
            if (href.indexOf('/cart/change') !== -1) {
              e.preventDefault();
              var url = new URL(link.href, window.location.origin);
              var lineParam = url.searchParams.get('line');
              var idParam = url.searchParams.get('id');
              var qtyParam = url.searchParams.get('quantity');
              var body;
              if (lineParam !== null) {
                body = { line: parseInt(lineParam, 10), quantity: qtyParam !== null ? parseInt(qtyParam, 10) : 0 };
              } else if (idParam !== null) {
                body = { id: idParam, quantity: qtyParam !== null ? parseInt(qtyParam, 10) : 0 };
              } else {
                window.location.href = link.href;
                return;
              }
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(body)
              }).then(function () { refreshCartDrawer(); });
            } else if (href === '/cart' || href.indexOf('/cart?') === 0 || href.indexOf(window.location.origin + '/cart') === 0) {
              return;
            }
          }
        });

        drawer.addEventListener('change', function (e) {
          var input = e.target;
          if (!input || input.type !== 'number') return;
          var line = input.getAttribute('data-line') || input.getAttribute('data-line-key') || (input.dataset ? (input.dataset.line || input.dataset.lineKey) : null);
          if (!line) {
            var li = input.closest('[data-cart-item], [data-line], [data-line-key]');
            if (li) {
              line = li.getAttribute('data-line') || li.getAttribute('data-line-key') || (li.dataset ? (li.dataset.line || li.dataset.lineKey) : null);
            }
          }
          var qty = parseInt(input.value, 10);
          if (isNaN(qty)) return;
          var body;
          if (line && !isNaN(parseInt(line, 10))) {
            body = { line: parseInt(line, 10), quantity: qty };
          } else if (line) {
            body = { id: line, quantity: qty };
          } else {
            return;
          }
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function () { refreshCartDrawer(); });
        });
      })();

      var form = root.querySelector('.csc-pdp__form');
      if (form) {
        form.setAttribute('data-product-form', '');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[data-csc-pdp-cta]');
          if (btn) {
            btn.setAttribute('disabled', '');
            btn.classList.add('is-loading');
          }

          var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var base = routeRoot.replace(/\/$/, '');
          var addUrl = base + '/cart/add.js';

          var currentMode = seg ? seg.getAttribute('data-csc-pdp-mode') : 'sub';
          var activeCard = root.querySelector('[data-csc-pdp-card="' + currentMode + '"].is-on');
          if (sellingPlanInput) {
            if (currentMode === 'sub' && activeCard) {
              sellingPlanInput.value = activeCard.getAttribute('data-plan-id') || '';
            } else {
              sellingPlanInput.value = '';
            }
          }
          if (qtyInput && activeCard) {
            if (currentMode === 'one') {
              qtyInput.value = activeCard.getAttribute('data-qty') || '1';
            } else {
              qtyInput.value = '1';
            }
          }

          form.querySelectorAll('[data-csc-pdp-discount-prop]').forEach(function (el) { el.parentNode.removeChild(el); });
          if (currentMode === 'sub' && activeCard) {
            var saveText = activeCard.querySelector('.csc-pdp__opt-save');
            if (saveText) {
              var match = saveText.textContent.match(/(\d+)\s*%/);
              if (match) {
                var discInput = document.createElement('input');
                discInput.type = 'hidden';
                discInput.name = 'properties[Discount]';
                discInput.value = match[1] + '%';
                discInput.setAttribute('data-csc-pdp-discount-prop', '');
                form.appendChild(discInput);
              }
            }
          }

          var formData = new FormData(form);
          console.log('[csc-pdp] add', Object.fromEntries(formData.entries()));
          if (currentMode === 'sub' && (!sellingPlanInput || !sellingPlanInput.value)) {
            console.warn('[csc-pdp] no selling_plan attached — cart will treat this as one-time. Check that subscription blocks match Shopify/Skio plan order.');
          }

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          })
            .then(function (r) {
              if (!r.ok) {
                return r.json().then(function (err) { throw err; }, function () { throw new Error('HTTP ' + r.status); });
              }
              return r.json();
            })
            .then(function (item) {
              console.log('[csc-pdp] added', item);

              var drawer = document.querySelector('[data-cart-drawer]');
              var template = document.querySelector('[data-cart-drawer-template]');
              var toggle = document.querySelector('[data-cart-drawer-toggle]');
              var isLoaded = drawer && drawer.querySelector('[data-items-holder]');

              if (drawer && !isLoaded && template) {
                console.log('[csc-pdp] drawer not loaded — rendering template');
                drawer.innerHTML = template.innerHTML;
              }

              return refreshCartDrawer().then(function () {
                var drawer2 = document.querySelector('[data-cart-drawer]');
                if (drawer2 && !document.body.classList.contains('js-drawer-open-cart')) {
                  drawer2.classList.remove('cv-h');
                  drawer2.classList.add('is-open');
                  document.body.classList.add('js-drawer-open-cart');
                  document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
                  document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: drawer2 }));
                  var drawerBody = drawer2.querySelector('[data-cart-drawer-body]');
                  if (drawerBody) {
                    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: drawerBody }));
                  }
                  var closeBtn = drawer2.querySelector('[data-cart-drawer-toggle]');
                  if (closeBtn && !closeBtn.hasAttribute('data-csc-bound')) {
                    closeBtn.setAttribute('data-csc-bound', '1');
                    closeBtn.addEventListener('click', function (e) {
                      e.preventDefault();
                      drawer2.classList.add('cv-h');
                      drawer2.classList.remove('is-open');
                      document.body.classList.remove('js-drawer-open-cart');
                      document.dispatchEvent(new CustomEvent('theme:cart:close', { bubbles: true }));
                      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: drawer2 }));
                    });
                  }
                }

                document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true, detail: { item: item } }));
                document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { item: item } }));
                return item;
              });
            })
            .catch(function (err) {
              console.error('[csc-pdp] add failed', err);
              var msg = (err && (err.description || err.message)) || 'Unable to add to cart.';
              alert(msg);
            })
            .finally(function () {
              if (btn) {
                btn.removeAttribute('disabled');
                btn.classList.remove('is-loading');
              }
            });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-csc-r]:not([data-csc-r-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-csc-r-init', '');

      var avatars = root.querySelectorAll('[data-csc-r-avatar]');
      var results = root.querySelectorAll('[data-csc-r-result]');
      var prevBtn = root.querySelector('[data-csc-r-prev]');
      var nextBtn = root.querySelector('[data-csc-r-next]');

      var total = avatars.length;
      if (total === 0) return;

      var current = 0;

      function setActive(i) {
        if (i < 0) i = total - 1;
        if (i >= total) i = 0;
        current = i;
        avatars.forEach(function (a, idx) { a.classList.toggle('is-active', idx === current); });
        results.forEach(function (r, idx) { r.classList.toggle('is-active', idx === current); });
        var activeAvatar = avatars[current];
        if (activeAvatar && typeof activeAvatar.scrollIntoView === 'function') {
          activeAvatar.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      avatars.forEach(function (a, i) {
        a.addEventListener('click', function () { setActive(i); });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });

      setActive(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-csc-ts]:not([data-csc-ts-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-csc-ts-init', '');

      var track = root.querySelector('[data-csc-ts-track]');
      var cards = root.querySelectorAll('[data-csc-ts-card]');
      var dots = root.querySelectorAll('[data-csc-ts-dot]');
      var prevBtn = root.querySelector('[data-csc-ts-prev]');
      var nextBtn = root.querySelector('[data-csc-ts-next]');
      var currentEl = root.querySelector('[data-csc-ts-current]');

      root.querySelectorAll('[data-csc-ts-video]').forEach(function (videoWrap) {
        var playBtn = videoWrap.querySelector('[data-csc-ts-play]');
        var videoEl = videoWrap.querySelector('[data-csc-ts-video-el]');
        if (!playBtn || !videoEl) return;
        playBtn.addEventListener('click', function () {
          root.querySelectorAll('[data-csc-ts-video].is-playing').forEach(function (other) {
            if (other !== videoWrap) {
              other.classList.remove('is-playing');
              var v = other.querySelector('[data-csc-ts-video-el]');
              if (v) { v.pause(); v.currentTime = 0; }
            }
          });
          videoWrap.classList.add('is-playing');
          var p = videoEl.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        });
        videoEl.addEventListener('ended', function () {
          videoWrap.classList.remove('is-playing');
          videoEl.currentTime = 0;
        });
      });

      if (!track || cards.length === 0) return;

      var total = cards.length;
      var current = 0;

      function isMobileTrack() {
        return getComputedStyle(track).overflowX !== 'visible';
      }

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function setActive(i, scroll) {
        if (i < 0) i = 0;
        if (i >= total) i = total - 1;
        current = i;
        dots.forEach(function (d, idx) {
          var on = idx === current;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (currentEl) currentEl.textContent = pad(current + 1);
        if (prevBtn) prevBtn.disabled = current <= 0;
        if (nextBtn) nextBtn.disabled = current >= total - 1;

        if (scroll && isMobileTrack()) {
          var card = cards[current];
          if (card) {
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        }
      }

      function updateFromScroll() {
        if (!isMobileTrack()) return;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        cards.forEach(function (c, i) {
          var cCenter = c.offsetLeft - track.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cCenter - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== current) setActive(best, false);
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateFromScroll);
      }, { passive: true });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { setActive(i, true); });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (isMobileTrack()) setActive(current - 1, true);
        else {
          var idx = current - 1;
          if (idx < 0) idx = total - 1;
          setActive(idx, false);
        }
      });

      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (isMobileTrack()) setActive(current + 1, true);
        else {
          var idx = current + 1;
          if (idx >= total) idx = 0;
          setActive(idx, false);
        }
      });

      setActive(0, false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
